import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const classDetail = () => import("@/views/orinbox/class/index.vue");
const toLock = () => import("@/views/orinbox/toLock/index.vue");
const trailCourse = () => import("@/views/orinbox/trailCourse/index.vue");

export default {
  path: "/orinbox",
  component: view,
  children: [
    {
      path: "course",
      component: classDetail
    },
    {
      path: "toLock",
      component: toLock
    },
    {
      path: "trailCourse",
      component: trailCourse
    },
  ]
};
